﻿import { Controller } from "@hotwired/stimulus";
import CriticalSection from "promise-critical-section";

export default class extends Controller {
    static get values() {
        return {
            url: String
        }
    }

    get isHoveredOrFocussed() {
        return this.isHovered || this.isFocussed;
    }

    constructor(context) {
        super(context);
        this.popoverVisibilityCriticalSection = new CriticalSection();
    }

    connect() {
        this.popover = new bootstrap.Popover(
            this.element,
            {
                content: "Loading...",
                customClass: "c-profile-popout",
                html: true,
                placement: "right",
                trigger: "manual"
            }
        );
        this.element.addEventListener("mouseenter", _ => this.setHovered());
        this.element.addEventListener("mouseleave", _ => this.unsetHovered());
        this.element.addEventListener("focus", _ => this.setFocussed());
        this.element.addEventListener("blur", _ => this.unsetFocussed());
    }

    disconnect() {
        if (this.popover) {
            this.popover.dispose();
            this.popover = null;
        }
    }

    async setHovered() {
        this.isHovered = true;
        await this.updatePopoverVisibility();
    }

    async unsetHovered() {
        this.isHovered = false;
        await this.updatePopoverVisibility();
    }

    async setFocussed() {
        this.isFocussed = true;
        await this.updatePopoverVisibility();
    }

    async unsetFocussed() {
        this.isFocussed = false;
        await this.updatePopoverVisibility();
    }

    async updatePopoverVisibility() {
        await this.popoverVisibilityCriticalSection.enter();

        if (this.popover) {
            if (this.isHoveredOrFocussed) {
                if (!this.popover.tip?.classList.contains("show")) {
                    await new Promise(r => { setTimeout(r, 500) });

                    if (this.popover && this.isHoveredOrFocussed) {
                        this.popover.show();
                        this.popover.tip.addEventListener(
                            "mouseenter",
                            () => {
                                if (this.popover.tip.classList.contains("show")) {
                                    this.setHovered();
                                }
                            }
                        );
                        this.popover.tip.addEventListener(
                            "mouseleave",
                            () => {
                                if (this.popover.tip.classList.contains("show")) {
                                    this.unsetHovered();
                                }
                            }
                        );

                        if (!this.content) {
                            this.content = await fetch(this.urlValue).then(r => r.text());
                        }

                        if (this.popover) {
                            this.popover.tip.querySelector(`.popover-body`).innerHTML = this.content;
                        }
                    }
                }
            } else if (this.popover.tip?.classList.contains("show")) {
                await new Promise(r => { setTimeout(r, 250) });

                if (this.popover && !this.isHoveredOrFocussed) {
                    this.popover.hide();
                }
            }
        }

        this.popoverVisibilityCriticalSection.leave();
    }
}